
import Advertisement from "@/components/Advertisement";
import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import RedSearchNow from "@/components/main/core/RedSearchNow";
import CheckBox from "@/components/main/core/CheckBox";
import BlogPost from "@/components/main/blog/BlogPost";
import RedHeadBox from "@/components/main/core/RedHeadBox";

import 'epic-spinners/dist/lib/epic-spinners.min.css'
import {BreedingRhombusSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'

import { email, required, minLength } from "vuelidate/lib/validators";

const StarRating = process.client ? require('vue-star-rating').default : undefined
import ClientOnly from 'vue-client-only'

import CtaSteps from "@/components/main/steps/CtaSteps";
import isMob576 from "@/mixins/isMob";
import "@/plugins/vuelidate"

export default {
  head() {
    const seoIitle = this.postData ? this.postData.data.seo_title : '';
    const description = this.postData ? this.postData.data.seo_description : '';

    return {
      title: seoIitle,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: seoIitle
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: seoIitle
        }
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `https://ifindcheaters.com/blog/${this.$route.params.slug}/`,
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://ifindcheaters.com/blog/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": this.postData ? this.postData.data.title : 'Post',
            }],
          },
        },

        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "http://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": `https://ifindcheaters.com/blog/${this.$route.params.slug}/`
            },
            "headline": this.postData ? this.postData.data.title : '',
            "image": this.postData ? this.postData.data.image.url : '',
            "datePublished": this.postData ? this.postData.data.created_at_formatted : '',
            "dateModified": this.postData ? this.postData.data.created_at_formatted : '',
            "author": {
              "@type": "Person",
              "name": this.postData ? this.postData.data.author.name : '',
              "url": this.postData ? this.postData.data.author.url : '',
            },
              "publisher": {
              "@type": "Organization",
              "name": "iFindCheaters",
              "logo": {
                "@type": "ImageObject",
                "url": "https://ifindcheaters.com/img/logo.png"
              }
            },
            "description": this.postData ? this.postData.data.excerpt : '',
          },
        }
      ]
    }
  },

  name: "slug",
  layout: 'clientLayout',
  mixins: [isMob576],
  components: {Advertisement, ClientHead, RedSection, RedSearchNow, CheckBox, BlogPost, RedHeadBox, BreedingRhombusSpinner, StarRating, ClientOnly, CtaSteps},
  data() {
    return {
      postData: null,
      popularPostsData: null,
      tagsData: null,
      categoriesData: null,
      showMore: false,
      rated: false,
      formLogin: {
        name: "",
        email: "",
      },
      isFixed: false,
    }
  },

  validations: {
    formLogin: {
      name: { required, minLength: minLength(2) },
      email: { email, required },
    },
  },

  async fetch() {
    try {
      const [postResponse, popularPostsResponse, tagsResponse, categoriesResponse] = await Promise.all([
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/${this.$route.params.slug}`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/posts/popular`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/tags`),
        this.$axios.get(`${process.env.BLOG_API_BASE_URL}/api/categories`),
      ]);

      this.postData = postResponse.data;
      this.popularPostsData = popularPostsResponse.data;
      this.tagsData = tagsResponse.data;
      this.categoriesData = categoriesResponse.data;
    } catch (error) {
      if(error.response.status === 404) {
        this.$router.push('/error.vue');
      }
      console.error('Error:', error);
    }
  },

  watch: {
    '$store.state.stepsUserModule.searchName': {
      immediate: true,
      handler(newName) {
        this.formLogin.name = newName;
      }
    },
    '$store.state.stepsUserModule.searchEmail': {
      immediate: true,
      handler(newEmail) {
        this.formLogin.email = newEmail;
      }
    },
  },

  computed: {
    title() {
      return this.postData.data.title
    },
    description() {
      return this.postData.data.excerpt
    },
    name: {
      get() {
        return this.$store.state.stepsUserModule.searchName;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_NAME', value);
      }
    },
    email: {
      get() {
        return this.$store.state.stepsUserModule.searchEmail;
      },
      set(value) {
        this.$store.commit('stepsUserModule/SET_SEARCH_USER_EMAIL', value);
      }
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // Проверка, находимся ли мы на мобильном устройстве
      if (this.isMob576) {
        this.isFixed = false; // Отключаем фиксацию на мобильных устройствах
        return;
      }

      const stickyBlock = this.$refs.stickyBlock; // Block CTA
      const prevBlock = this.$refs.prevBlock; // Block advertisement
      const footer = document.querySelector('.footer'); // Block footer
      if (!stickyBlock || !prevBlock || !footer) {
        return;
      }

      const headerHeight = 90; // Height header
      const prevBlockRect = prevBlock.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();

      const prevBlockBottomVisible = prevBlockRect.bottom <= headerHeight;
      const footerVisible = footerRect.top <= window.innerHeight;

      this.isFixed = prevBlockBottomVisible && !footerVisible;
    },
    redirectUser() {
      this.name = this.formLogin.name;
      this.email = this.formLogin.email;

      if (!this.formLogin.name || !this.formLogin.email) {
        return;
      }

      this.$router.push(`${this.$store.state.userModule.isLogged ? '/account/dashboard/' : '/auth/register?plan=1&product=FREE'}`)
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    setRating(rating) {
      if (!this.rated) {
        this.postData.data.rating.count++
        this.postData.data.rating.rating = ((this.postData.data.rating.rating * this.postData.data.rating.count + rating) / this.postData.data.rating.count).toFixed(2);
        this.rated = true
      }
    },
  },
}
